import { call, put, takeLatest } from 'redux-saga/effects';
import { dialog as actions } from 'flux/actions';
import errorHandler from 'errorHandler';
import React from 'react';

function* fetchDialogContent(action) {
  try {
    const response = yield call(fetch, action.payload.url);
    const content = yield response.text();
    yield put({
      type: actions.types.SET_CONTENT,
      content: React.createElement('div', { dangerouslySetInnerHTML: { __html: content } }),
    });
  } catch (e) {
    errorHandler(e, true);
  }
}

export default function* () {
  yield takeLatest(actions.types.FETCH_DIALOG_CONTENT, fetchDialogContent);
}
